(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["epac-booking-listing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-epac-booking]').forEach((root) => {
    // Three audiences since 2026-08-05: an athlete buys for themselves, a coach buys
    // their own development, a club buys for its players and staff. Anything
    // unrecognised falls back to athlete, which is the largest audience by far.
    const AUDIENCES = ['athlete', 'coach', 'club'];
    const AUDIENCE = root.getAttribute('data-epac-audience') || 'athlete';
    const PROGRAMME_META = {
      'private-training': { name: 'Private Group Training', icon: '🎯' },
      // The four weekly SPECIALIST SESSIONS (owner 2026-08-04). These replaced
      // technical-training and position-specific: Technical & Physical became
      // Mastering the Ball, Performance Striker became Creating & Finishing, and the
      // other two are new. All four are covered by membership; the rest are not.
      // `step` names the Player Pathway stage a session is pitched at (owner
      // 2026-08-05). Declared on the PROGRAMME rather than derived from each
      // product's epac.level, because it is a property of the offering: a tile
      // must show the right step even in a region where no product exists yet.
      'foundations-first': { name: 'Foundations First', icon: '🌱', step: 'Development' },
      'mastering-the-ball': { name: 'Mastering the Ball', icon: '⚡', step: 'Performance' },
      'defending-denying': { name: 'Defending & Denying', icon: '🛡️', step: 'Performance' },
      'creating-finishing': { name: 'Creating & Finishing', icon: '🥅', step: 'Performance', note: 'Goalkeepers can also attend' },
      'complete-goalkeeping': { name: 'Complete Goalkeeping', icon: '🧤', step: 'Performance' },
      camps: { name: 'Training Camps', icon: '⚽' },
      'performance-analysis': { name: 'Performance Analysis', icon: '📊' },
      'free-training': { name: 'Free Training', icon: '🎟️' },
      homeschool: { name: 'Homeschool', icon: '🏠' },
      // Two DIFFERENT products, and the names have to carry that on their own —
      // a club buying staff development and an individual coach buying a seat are
      // not the same purchase (owner 2026-07-16). "for Clubs" matches the product
      // title; "for Individual Coaches" is what stops a club booking a single seat
      // by mistake. Endpoint badges reinforce it: Enquiry vs Book.
      'coach-education-club': { name: 'Coach Education for Clubs', icon: '🎓' },
      'coach-education-seminar': { name: 'Seminars for Individual Coaches', icon: '📋' },
      'club-residency': { name: 'Club Residency', icon: '🏟️' },
    };
    // The age filters are the pathway tier splits: Development runs U6 to U14 split
    // at 9, Performance and Goalkeeper run U8 to U16 split at 12. Listed by youngest
    // age rather than by tier, because a parent picks the row their child falls in.
    const AGES = ['U6–U9', 'U8–U12', 'U10–U14', 'U13–U16'];

    // Matching is by CONTAINMENT, not string equality and not overlap.
    //
    // Equality hides the sessions run as one combined group, whose band spans two
    // filters (U6 to U14, U8 to U16): they would appear under neither.
    //
    // Overlap is worse, and not obviously so. The bands share their edges, so U6-U9
    // overlaps U8-U12 on two years, and every filter then returns every session type:
    // a six year old is shown Performance sessions built for twelve year olds.
    //
    // Containment either way is what is actually meant. A combined U6 to U14 group
    // contains the U6-U9 filter so it shows there; a U8-U12 session neither contains
    // U6-U9 nor is contained by it, so it stays out.
    function ageRange(label) {
      const m = String(label).match(/U(\d+)\D+U(\d+)/i);
      return m ? [Number(m[1]), Number(m[2])] : null;
    }
    function ageOverlaps(band, filterLabel) {
      const a = ageRange(formatAgeBand(band)), b = ageRange(filterLabel);
      if (!a || !b) return false;
      const contains = (x, y) => x[0] <= y[0] && y[1] <= x[1];
      return contains(a, b) || contains(b, a);
    }
    const LEVEL_LABEL = { rec: 'Recreational', competitive: 'Competitive' };
    const MONTH_ORDER = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const PAGE_SIZE = 8;

    // Region pill order, owner 2026-08-07: USA, UK, Europe, Australia. Shopify
    // returns metaobjects alphabetically, which put Australia and Europe first and
    // buried the two markets that actually have sessions on sale. Ordered here in
    // code rather than by reordering the metaobjects, because the owner's store
    // recreates those from scratch and would land back on alphabetical.
    // Anything not listed keeps its original position, after the ones that are.
    const REGION_ORDER = ['us', 'uk', 'eu', 'au'];
    const regionRank = (code) => { const i = REGION_ORDER.indexOf(code); return i === -1 ? REGION_ORDER.length : i; };
    const regions = JSON.parse(document.querySelector('[data-epac-regions-data]').textContent)
      .sort((a, b) => regionRank(a.code) - regionRank(b.code));
    const products = JSON.parse(document.querySelector('[data-epac-products-data]').textContent);
    const serviceTypeOrder = JSON.parse(document.querySelector('[data-epac-service-type-order]').textContent);
    const EPAC_LOGO_URL = JSON.parse(document.querySelector('[data-epac-logo-url]').textContent);
    const groupIntros = JSON.parse(document.querySelector('[data-epac-group-intros]').textContent);
    const groupCards = JSON.parse(document.querySelector('[data-epac-group-cards]').textContent);

    const regionName = (code) => { const r = regions.find((x) => x.code === code); return r ? r.name : 'your region'; };

    // "Launched" = EPAC operates here (the region has cities), regardless of what's
    // listed today. An established region with nothing on right now must NOT be told
    // the reduced new-market groups — it gets "None available at this time" (owner
    // 2026-07-14). Fail-safe: an empty list means we couldn't tell, so treat every
    // region as launched — the conservative message.
    let LAUNCHED = new Set();
    try {
      const el = document.querySelector('[data-epac-launched-regions]');
      if (el) LAUNCHED = new Set(JSON.parse(el.textContent));
    } catch (_) {}
    const isLaunched = (code) => LAUNCHED.size === 0 || LAUNCHED.has(code);

    // ---- Step 1b grouping (spec: booking-finder-spec.md) ----
    // The old single "EXPLORE THE PATHWAY" heading had become a catch-all sitting
    // above Academy/EPAC Club AND unrelated services. Group by what each service IS;
    // the ACTION (Book / Register / Enquiry) is a badge on each tile/card instead,
    // so theme and action stay separate. "The academy pathway" is reserved for
    // Academy → EPAC Club only.
    //
    // A group member is either:
    //   { tile: '<service_type>' } — bookable, rendered from products with a live
    //     session count; omitted automatically when the region has no sessions.
    //   { card: '<CARDS key>' }    — info/enquiry page, always shown.
    const CARDS = {
      // Deliberately the FIRST member of the specialist-sessions group: a parent should
      // see the membership before they price up individual sessions. Rendered dark with
      // a gold accent so it reads as the premium option rather than a fifth session.
      membership: { st: 'membership', href: '/pages/membership', icon: '🎟️', title: 'EPAC Membership', badge: 'From $119 / month', desc: 'Development, Goalkeeper and Performance memberships, each covering multiple weekly sessions inside that pathway, plus 20% off camps and private training. Book sessions the same way as everyone else. The membership just pays for them.' },
      academy: { st: 'academy', href: '/pages/academy', icon: '🏆', title: 'EPAC High Performance Academy', badge: 'Register', desc: 'Invitation-only, with position-specific coaching, GPS tracking and a pathway to EPAC Club.' },
      // "Completely free" leads the description on purpose (owner 2026-08-07). It is
      // the headline benefit, and this card is where an athlete browsing services
      // meets EPAC Club: the homepage pathway and the EPAC Club page said it, this
      // did not. Badge stays Enquiry because a place is earned, not bought.
      'epac-club': { st: 'epac-club', href: '/pages/epac-club', icon: '⚽', title: 'EPAC Club', badge: 'Enquiry', desc: 'Completely free for selected players: no registration, membership or fixture fees. The highest stage of the pathway, with representative football and international experiences.' },
      homeschool: { st: 'homeschool', href: '/pages/home-school', icon: '🏠', title: 'Home School', badge: 'Sign up', level: ['rec'], hideIn: ['uk'], desc: 'Academy-standard coaching for home-educated players: structured daytime monthly blocks in small, focused groups.' },
      // Performance Analysis sells as FOUR products (page.performance-analysis.json):
      // video and GPS, each individual or team. The finder used to lump them into one
      // "Performance Analysis" card per audience, which hid the choice and the price.
      // Owner 2026-08-07: surface GPS and Video separately under every audience.
      // Individual for athletes; team for coaches and clubs, who buy for a squad.
      // Prices mirror the page — change them in both places or the finder lies.
      'analysis-gps': { st: 'performance-analysis', href: '/pages/performance-analysis', icon: '📡', title: 'GPS Performance Analysis', badge: 'Enquiry', level: ['rec'], desc: 'Hire an EPAC GPS pod for your match: total distance, high-speed running, sprint count and max speed, with a match report and benchmarking game to game. From $99.' },
      'analysis-video': { st: 'performance-analysis', href: '/pages/performance-analysis', icon: '🎥', title: 'Video Performance Analysis', badge: 'Enquiry', level: ['rec'], desc: 'Position-specific analysis of your Veo match footage: key-moment clips, technical and tactical feedback, a full report and a live online review. From $150.' },
      'analysis-gps-team': { st: 'performance-analysis', href: '/pages/performance-analysis', icon: '📡', title: 'GPS Performance Analysis', badge: 'Enquiry', level: ['rec'], desc: 'Hire EPAC GPS pods for match day: full squad and individual distance, high-speed running, sprint data and workload monitoring, with reports for both. From $160.' },
      'analysis-video-team': { st: 'performance-analysis', href: '/pages/performance-analysis', icon: '🎥', title: 'Video Performance Analysis', badge: 'Enquiry', level: ['rec'], desc: 'Team and opposition analysis from your Veo footage: key stats, shot maps, key-moment clips and tactical feedback, with a team presentation or coach report. From $150.' },
      'club-residency': { st: 'club-residency', href: '/pages/club-residency', icon: '🏟️', title: 'Club Residency', badge: 'Enquiry', level: ['rec'], desc: 'Embed a professional EPAC coach in your club: coach education, full team support, match-day leadership and analysis. Fully managed by EPAC.' },
      // The coach audience would otherwise be a single tile. Careers is a genuine
      // route for an individual coach and the page already exists, so it earns a
      // place rather than padding the group out.
      careers: { st: 'careers', href: '/pages/careers', icon: '🎯', title: 'Coaching Opportunities', badge: 'Apply', level: ['rec'], desc: 'Apply to join the EPAC Coaching Network and be considered for opportunities across our programmes, locations and international projects. Specialist analyst and coach educator roles too.' },
      // Stand-in for the individual-coach seminar when no dates are on sale in
      // this region (owner 2026-07-16). Rendered ONLY as a tile fallback, so the
      // moment staff publish a seminar the real bookable tile takes over and this
      // disappears with no code change. Between programmes, a coach who'd have
      // hit a silently missing tile now has something to do.
      'coach-seminars-soon': { st: 'coach-education-seminar', href: '/pages/contact', icon: '📋', title: 'Seminars for Individual Coaches', badge: 'Currently unavailable', level: ['rec'], desc: 'No seminar dates are on sale in your region right now. Register your interest and we\'ll let you know first when the next dates are announced.' },
      // Fallbacks for the four specialist sessions. These are the headline weekly
      // offering, so all four should be visible in every region even before dates are
      // on sale — a tile with no products would otherwise vanish and make the range
      // look half-built. Defending and Goalkeeping have no products anywhere yet.
      //
      // `level` here must match the level the real products will carry, because the
      // 5px top bar is painted from it by accentFor(). Get it wrong and a fallback
      // card wears a different colour from the same tile once products exist, and
      // from its own pathway-step chip. Performance sessions are 'competitive';
      // Foundations First is the recreational entry point, so 'rec'.
      'foundations-soon': { st: 'foundations-first', href: '/pages/contact?reason=Foundations%20First', icon: '🌱', title: 'Foundations First', badge: 'Dates coming soon', step: 'Development', level: ['rec'], desc: 'Entry-level development for beginner and recreational players. Register your interest and we\'ll tell you first when dates are released.' },
      'mastering-soon': { st: 'mastering-the-ball', href: '/pages/contact?reason=Mastering%20the%20Ball', icon: '⚡', title: 'Mastering the Ball', badge: 'Dates coming soon', step: 'Performance', level: ['competitive'], desc: 'Weekly technical work: first touch, ball mastery, striking technique and confidence in possession. Register your interest and we\'ll tell you first when dates are released.' },
      'defending-soon': { st: 'defending-denying', href: '/pages/contact?reason=Defending%20%26%20Denying', icon: '🛡️', title: 'Defending & Denying', badge: 'Dates coming soon', step: 'Performance', level: ['competitive'], desc: 'Weekly defensive work: individual duels, positioning, pressing and denying space. Register your interest and we\'ll tell you first when dates are released.' },
      'creating-soon': { st: 'creating-finishing', href: '/pages/contact?reason=Creating%20%26%20Finishing', icon: '🥅', title: 'Creating & Finishing', badge: 'Dates coming soon', step: 'Performance', level: ['competitive'], desc: 'Weekly attacking work: creating chances, movement in the final third and finishing under pressure. Register your interest and we\'ll tell you first when dates are released.' },
      'goalkeeping-soon': { st: 'complete-goalkeeping', href: '/pages/contact?reason=Complete%20Goalkeeping', icon: '🧤', title: 'Complete Goalkeeping', badge: 'Dates coming soon', step: 'Performance', level: ['competitive'], desc: 'Weekly specialist goalkeeping: handling, shot-stopping, distribution and playing out from the back. Register your interest and we\'ll tell you first when dates are released.' },
    };
    // NEW MARKETS (regions we haven't launched in — currently EU/AU) get a much
    // simpler, honest list instead of the full launched-region groups (owner
    // 2026-07-15). The launched groups surface Home School / Academy / EPAC Club,
    // which are US-only (Loomis, CA) — an Australian parent was being shown
    // programmes they cannot attend. Here we show ONLY what genuinely travels:
    // remote and enquiry services a visitor can act on today.
    // The "currently unavailable" cards that used to sit alongside them (Training
    // Camps, Coach Education Events) were both dropped 2026-07-16 — a dead card
    // under a heading reading "Available in your region" gave nobody anything to
    // do. The groups below carry what actually travels to these regions.
    // Cards for regions with no city metaobjects (currently EU and AU). EPAC has
    // ALREADY operated in both, so nothing here may read as a future launch
    // (owner 2026-08-07). Analysis is the video product only: GPS needs a physical
    // pod on match day, video works from Veo footage anywhere.
    const NEW_MARKET_CARDS = {
      'camps-back-soon': { st: 'camps', href: '/pages/contact?reason=Training%20Camps', icon: '🌍', title: 'Training Camps', badge: 'We\'ll be back soon', level: ['rec'], desc: 'EPAC camps have run here before and will again. Register your interest and we\'ll tell you first when the next dates are set.' },
      'coach-ed-club': { st: 'coach-education-club', href: '/pages/clubs-coaches', icon: '🎓', title: 'Coach Education for Clubs', badge: 'Enquiry', level: ['rec'], desc: 'Your CLUB hires EPAC to develop its own coaching staff: English academy standards brought to your coaches, delivered remotely. Enquire for a quote.' },
      'camps-club': { st: 'camps', href: '/pages/contact?reason=Training%20Camps', icon: '🌍', title: 'Club Training Camps', badge: 'Enquiry', level: ['rec'], desc: 'Host an EPAC camp at your club, delivered by English academy coaches. Enquire and we\'ll talk through dates and what\'s involved.' },
    };
    // Structure set by the owner 2026-08-07, mirroring the launched markets but
    // carrying only what actually travels: camps EPAC will run again, seminars, club
    // work, and remote video analysis. Each tile keeps a fallback so a group never
    // renders empty, and the tile takes over automatically once dates are on sale.
    const NEW_MARKET_GROUPS = {
      athlete: [
        { label: 'Training camps', accent: '#E30613', members: [{ tile: 'camps', fallback: 'camps-back-soon' }] },
        { label: 'Analysis', accent: '#020E38', members: [{ card: 'analysis-video' }] },
      ],
      coach: [
        { label: 'Coach development', accent: '#020E38', members: [{ tile: 'coach-education-seminar', fallback: 'coach-seminars-soon' }] },
        { label: 'Analysis', accent: '#0077B6', members: [{ card: 'analysis-video-team' }] },
      ],
      club: [
        { label: 'Club development', accent: '#E30613', members: [{ card: 'club-residency' }, { tile: 'camps', fallback: 'camps-club' }] },
        { label: 'Analysis', accent: '#0077B6', members: [{ card: 'analysis-video-team' }] },
      ],
    };

    // `accent` drives the Step 1b left accent bar. Colours follow the pathway system
    // (blue = development, gold = academy, red = clubs, navy = EPAC/analysis) and
    // NEIGHBOURS MUST DIFFER — check the sequence here, not just the individual
    // value, when adding or reordering a group.
    // Structure set by the owner 2026-08-07: every service sits under the customer
    // type that buys it, with the same shape in both launched markets (US and UK).
    // That falls out of this config rather than needing per-market lists — a launched
    // region reads GROUPS, an unlaunched one reads NEW_MARKET_GROUPS, and the region
    // pill only filters which PRODUCTS a tile finds.
    const GROUPS = {
      athlete: [
        // Split from the rest because the commercial model differs: these weekly
        // sessions are reached through a membership, everything below is bought
        // outright.
        { label: 'Specialist sessions', accent: '#0077B6', scheduleLink: true, members: [{ card: 'membership' }, { tile: 'foundations-first', fallback: 'foundations-soon' }, { tile: 'mastering-the-ball', fallback: 'mastering-soon' }, { tile: 'defending-denying', fallback: 'defending-soon' }, { tile: 'creating-finishing', fallback: 'creating-soon' }, { tile: 'complete-goalkeeping', fallback: 'goalkeeping-soon' }] },
        { label: 'Camps & private training', accent: '#E30613', members: [{ tile: 'camps' }, { card: 'homeschool' }, { tile: 'private-training' }] },
        { label: 'Player pathway', accent: '#FFB703', members: [{ card: 'academy' }, { card: 'epac-club' }] },
        { label: 'Analysis', accent: '#020E38', members: [{ card: 'analysis-gps' }, { card: 'analysis-video' }] },
      ],
      // COACH is an individual buying their own development, priced per coach rather
      // than per club (owner 2026-08-05). The seminar tile falls back to a
      // register-interest card between programmes, so this never renders empty.
      coach: [
        { label: 'Coach development', accent: '#020E38', members: [{ tile: 'coach-education-seminar', fallback: 'coach-seminars-soon' }] },
        { label: 'Analysis', accent: '#0077B6', members: [{ card: 'analysis-gps-team' }, { card: 'analysis-video-team' }] },
        { label: 'Coach with EPAC', accent: '#E30613', members: [{ card: 'careers' }] },
      ],
      // CLUB is an organisation buying for its players and its staff. Coach education
      // stays here in its CLUB form (the club hires EPAC to develop its own coaches),
      // which is a different sale from an individual buying a seminar place.
      club: [
        // Camps for clubs are an ENQUIRY in the services spec, not a bookable product,
        // so in launched regions the camps tile finds nothing (every camps product is
        // audience: athlete) and the fallback card carries the club offering instead.
        { label: 'Club development', accent: '#E30613', members: [{ card: 'club-residency' }, { tile: 'camps', fallback: 'camps-club' }] },
        { label: 'Coach education', accent: '#020E38', members: [{ tile: 'coach-education-club' }] },
        { label: 'Analysis', accent: '#0077B6', members: [{ card: 'analysis-gps-team' }, { card: 'analysis-video-team' }] },
      ],
    };
    const BADGE_FOR_ENDPOINT = { book: 'Book', register: 'Register', enquiry: 'Enquiry' };
    const BADGE_CLASS = {
      Book: 'epac-bg-red/10 epac-text-red',
      Register: 'epac-bg-navy/10 epac-text-navy',
      Enquiry: 'epac-bg-blue/10 epac-text-blue',
      // Not an action — a state. Muted grey so it reads as "not yet" rather than
      // as something you can do. Emitted by the seminar tile's fallback card.
      'Currently unavailable': 'epac-bg-gray-100 epac-text-mute',
    };
    // `dark` = sits on the navy EPAC Club card, where the tinted styles go
    // near-invisible (Enquiry is blue-on-navy). Render white so it pops.
    function badgeHtml(label, dark) {
      const cls = dark
        ? 'epac-bg-white epac-text-navy'
        : (BADGE_CLASS[label] || 'epac-bg-navy/10 epac-text-navy');
      return `<span class="epac-text-[10px] epac-eyebrow epac-font-bold epac-px-2 epac-py-0.5 epac-rounded epac-whitespace-nowrap ${cls}">${escapeHtml(label.toUpperCase())}</span>`;
    }

    const regionPillsEl = root.querySelector('[data-epac-region-pills]');
    const step1El = root.querySelector('[data-epac-step1]');
    const step2El = root.querySelector('[data-epac-step2]');
    const groupsEl = root.querySelector('[data-epac-groups]');
    const resultsEl = root.querySelector('[data-epac-results]');
    const loadMoreEl = root.querySelector('[data-epac-load-more]');

    // ---- Default region: geolocate via Shopify Markets, then keep it in sync with
    // the country selector. Was defaulting first-time visitors to regions[0] (AU)
    // regardless of location (owner 2026-07-24). Map the visitor's country to one of
    // the EPAC operating regions (us / uk / eu / au); unknown countries fall back to
    // the primary market (US) rather than the first region in the list.
    const EU_ISO = new Set(['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','NO','IS','LI','CH']);
    function countryToRegion(iso) {
      iso = String(iso || '').toUpperCase();
      if (iso === 'GB') return 'uk';
      if (iso === 'AU' || iso === 'NZ') return 'au';
      if (iso === 'US' || iso === 'CA') return 'us';
      if (EU_ISO.has(iso)) return 'eu';
      return null;
    }
    const regionExists = (code) => !!(code && regions.some((r) => r.code === code));
    const fallbackRegion = regionExists('us') ? 'us' : ((regions[0] && regions[0].code) || 'us');
    let shopCountry = '';
    try { shopCountry = JSON.parse(document.querySelector('[data-epac-shop-country]').textContent) || ''; } catch (_) {}
    let geoRegionCode = countryToRegion(shopCountry);
    if (!regionExists(geoRegionCode)) geoRegionCode = null;
    // Sync rule: if the Shopify country changed since last visit (or it's a first
    // visit), the selector/geolocation wins and the region follows it. Otherwise we
    // honour an explicit in-page pill choice saved in localStorage. Pill clicks still
    // override until the next time the country selector changes.
    const lastShopCountry = window.localStorage.getItem('epacShopCountry') || '';
    let currentRegionCode;
    if (shopCountry && shopCountry !== lastShopCountry) {
      currentRegionCode = geoRegionCode || fallbackRegion;
      window.localStorage.setItem('epacShopCountry', shopCountry);
      window.localStorage.setItem('epacRegionCode', currentRegionCode);
    } else {
      currentRegionCode = window.localStorage.getItem('epacRegionCode') || geoRegionCode || fallbackRegion;
    }
    let programme = null;
    let filters = { focus: 'all', state: 'all', age: [], when: [], level: 'all', venue: 'all' };
    let shown = PAGE_SIZE;

    function escapeHtml(str) { const d = document.createElement('div'); d.textContent = str == null ? '' : String(str); return d.innerHTML; }
    // Group accents go into a style="" custom property, so anything that isn't a
    // plain hex is dropped rather than concatenated into the CSS — a stray quote or
    // semicolon in a config value can't escape the declaration. Falls back to navy.
    function cssColor(v) { return /^#[0-9a-f]{3}([0-9a-f]{3})?$/i.test(String(v || '')) ? v : '#020E38'; }
    function regionByCode(code) { return regions.find((r) => r.code === code) || regions[0]; }
    function citySubLabel(code) { return code === 'uk' ? 'County' : code === 'eu' || code === 'au' ? 'Region' : 'State'; }
    function formatAgeBand(raw) { return raw.toUpperCase().replace('-', '–'); }
    // Short "focus" label from epac.programme — a position sub-filter WITHIN a tile.
    // TRUE POSITIONS ONLY (owner 2026-07-14: "technical and physical are not positions").
    //
    // Since the 2026-08-04 restructure this legitimately matches nothing: position is
    // now the tile itself (Defending & Denying, Complete Goalkeeping, Creating &
    // Finishing), so a second position filter inside one would be redundant. The FOCUS
    // row hides itself when fewer than two focuses exist — see buildFilterUI. Kept
    // because a future programme may again mix positions under a single service type.
    function focusOf(prog) {
      if (/striker/i.test(prog)) return 'Striker';
      if (/goalkeep|\bgk\b/i.test(prog)) return 'GK';
      if (/defend/i.test(prog)) return 'Defender';
      return '';
    }
    // Row/detail title: venue, plus the block/programme label when set (so the four
    // striker blocks at one venue read "Foskett Park · Block One/Two/…"). No venue →
    // the product title (which already carries the context, e.g. a bundle name).
    function titleOf(s) { return s.venue ? (s.venue + (s.groupLabel ? ' · ' + s.groupLabel : '')) : s.productTitle; }
    function monthOf(s) {
      if (!s) return '';
      const m = String(s).match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/i);
      return m ? m[0][0].toUpperCase() + m[0].slice(1, 3).toLowerCase() : '';
    }
    // A single-date variant label (month name, a day-ordinal like "Sat 11th",
    // or a numeric date) vs. a non-date label (block/week/"Full Programme").
    function looksLikeDate(s) {
      if (!s) return false;
      return /\b(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i.test(s) || /\d+\s*(st|nd|rd|th)\b/i.test(s) || /\d{1,2}[\/-]\d{1,2}/.test(s);
    }

    // ---- sessions: expand each product's variants into bookable rows ----
    const SESSIONS = [];
    products.forEach((p) => {
      const commonBase = {
        productId: p.id, serviceType: p.serviceType, endpoint: p.endpoint,
        regions: p.regions || [], states: p.cities || [], venue: p.venue || '',
        ageBand: p.ageBand || [], level: p.level || [], remote: !!p.remote,
        image: p.image, imageLarge: p.imageLarge, productTitle: p.title, capacity: Number(p.capacity) || 0,
        category: p.category || '', field: p.field || '', datesList: p.dates || '', groupLabel: p.groupLabel || '',
        programme: p.programme || '', focus: focusOf(p.programme || ''), featured: p.featured === true,
      };
      if (p.endpoint === 'enquiry') {
        SESSIONS.push({ ...commonBase, variantId: p.variants[0] && p.variants[0].id, when: '', time: p.sessionTime || '', month: '', price: 0, priceFormatted: 'Enquire', left: null, total: null });
        return;
      }
      // Delivery-mode products (coach-education seminars: In-Person / Online, each
      // its own price + inventory) collapse into ONE bookable row; the detail card
      // renders a mode PICKER so the buyer chooses before Add-to-booking, rather
      // than listing each mode as a separate session (booking-finder-spec #3).
      const axis = (p.options || [])[0] || '';
      if ((p.options || []).length === 1 && /delivery|mode|format/i.test(axis)) {
        const modes = (p.variants || []).map((v) => ({
          id: v.id, name: v.option1 || axis, price: Number(v.price),
          priceFormatted: Number(v.price) > 0 ? v.priceFormatted : 'Free', left: v.inventoryQuantity,
        }));
        const inStock = modes.filter((m) => m.left == null || m.left > 0);
        const def = inStock.slice().sort((a, b) => a.price - b.price)[0] || modes[0];
        const totalLeft = modes.reduce((a, m) => a + (m.left == null ? 9999 : Math.max(0, m.left)), 0);
        SESSIONS.push({
          ...commonBase, variantId: def && def.id, modes, modeIdx: modes.indexOf(def),
          when: '', time: p.sessionTime || '', month: monthOf(p.dates || ''),
          price: def ? def.price : 0, priceFormatted: def ? def.priceFormatted : '',
          left: totalLeft, total: p.capacity ? Number(p.capacity) : totalLeft,
        });
        return;
      }
      (p.variants || []).forEach((v) => {
        const opt1 = v.option1 && v.option1 !== 'Default Title' ? v.option1 : '';
        const opt2 = v.option2 && v.option2 !== 'Default Title' ? v.option2 : '';
        const when = opt1 || p.dates || '';
        SESSIONS.push({
          ...commonBase, variantId: v.id,
          when, time: opt2 || p.sessionTime || '', month: monthOf(when),
          price: Number(v.price), priceFormatted: Number(v.price) > 0 ? v.priceFormatted : 'Free',
          left: v.inventoryQuantity, total: p.capacity ? Number(p.capacity) : v.inventoryQuantity,
        });
      });
    });
    SESSIONS.forEach((s, i) => { s._id = i; });

    // Sold-out sessions are hidden everywhere (results, venue dropdown, tile
    // counts). Enquiry / no-inventory rows (left == null) are always available.
    function isAvailable(s) { return s.left == null || s.left > 0; }
    // A session is hidden once its date has passed. Nothing else did this: the only
    // filter was inventory, so a session that had already run stayed bookable until it
    // sold out. Sorting soonest-first made it worse by putting the stalest row on top.
    //
    // Undated rows (enquiry cards, open-ended programmes) return Infinity and always
    // survive; the store's own stock is still the check for sold out.
    function todayVal() {
      const n = new Date();
      return n.getFullYear() * 10000 + (n.getMonth() + 1) * 100 + n.getDate();
    }
    function isUpcoming(s) {
      const v = firstDateVal(s);
      return v === Infinity || v >= todayVal();
    }
    function sessionsForProgramme(pt) {
      return SESSIONS.filter((s) => s.serviceType === pt && s.regions.includes(currentRegionCode) && isAvailable(s) && isUpcoming(s));
    }

    // ---- region selector (country) ----
    function setRegion(code, dispatch = true) {
      currentRegionCode = code;
      const region = regionByCode(code);
      if (region) {
        window.localStorage.setItem('epacRegionCode', code);
        window.localStorage.setItem('epacRegion', region.name);
        document.querySelectorAll('[data-epac-region-label-mirror], [data-epac-region-label]').forEach((el) => (el.textContent = region.name));
        if (dispatch) window.dispatchEvent(new CustomEvent('epacregionchange', { detail: { name: region.name, code } }));
      }
      backToProgrammes();
      renderRegionPills();
      renderGroups();
    }
    window.addEventListener('epacregionchange', (e) => {
      if (!e.detail || !e.detail.code || e.detail.code === currentRegionCode) return;
      setRegion(e.detail.code, false);
    });
    function renderRegionPills() {
      if (regions.length < 2) { regionPillsEl.innerHTML = ''; return; }
      regionPillsEl.innerHTML = regions.map((r) => `<button type="button" class="epac-rpill${r.code === currentRegionCode ? ' is-active' : ''}" data-region-code="${r.code}">${escapeHtml(r.name)}</button>`).join('');
      regionPillsEl.querySelectorAll('button').forEach((btn) => btn.addEventListener('click', () => setRegion(btn.dataset.regionCode)));
    }

    // ---- STEP 1: grouped programmes (spec Step 1b) ----
    // Pathway step chip. Colours match the Player Pathway stages on the homepage
    // (Development blue, Performance red, Academy gold) so a parent who has seen
    // that section recognises where a session sits without reading the label.
    // Colours are resolved INSIDE the function on purpose. ACCENT_BLUE and friends
    // are declared further down this IIFE, so a const map up here hits the temporal
    // dead zone and throws "Cannot access 'ACCENT_BLUE' before initialization",
    // which kills render() and leaves the whole finder blank.
    function stepHtml(step) {
      if (!step) return '';
      const colours = { Development: ACCENT_BLUE, Performance: ACCENT_RED, Academy: ACCENT_GOLD };
      const c = colours[step] || ACCENT_BLUE;
      return `<span class="epac-text-[10px] epac-font-bold epac-eyebrow epac-px-2 epac-py-0.5 epac-rounded epac-whitespace-nowrap" style="color:${c};background:${c}1A">${escapeHtml(step)} step</span>`;
    }

    function tileHtml(pt) {
      const meta = PROGRAMME_META[pt];
      const rows = sessionsForProgramme(pt);
      if (!meta || !rows.length) return ''; // no sessions in this region → omit
      const desc = (groupIntros[pt] || '').replace(/<[^>]+>/g, '').slice(0, 90);
      const badge = badgeHtml(BADGE_FOR_ENDPOINT[rows[0].endpoint] || 'Book');
      // Colour from the levels actually present in this tile's sessions.
      const accent = accentFor(pt, rows.reduce((acc, r) => acc.concat(r.level || []), []));
      const step = stepHtml(meta.step);
      const note = meta.note ? `<div class="epac-text-[11px] epac-text-mute epac-italic epac-mb-2">${escapeHtml(meta.note)}</div>` : '';
      return `<div class="epac-tile epac-rounded-2xl epac-border epac-border-gray-200 epac-overflow-hidden" data-programme="${pt}">
        <div style="height:5px;background:${accent}"></div>
        <div class="epac-p-5">
          <div class="epac-flex epac-items-start epac-justify-between epac-gap-2 epac-mb-2"><span class="epac-text-2xl">${meta.icon}</span>${badge}</div>
          <div class="epac-font-semibold epac-text-navy epac-text-lg">${escapeHtml(meta.name)}</div>
          ${step ? `<div class="epac-mt-1.5 epac-mb-2">${step}</div>` : ''}
          <div class="epac-text-sm epac-text-mute epac-mb-2">${escapeHtml(desc)}</div>
          ${note}
          <div class="epac-text-xs epac-font-semibold epac-text-red">${rows.length} session${rows.length === 1 ? '' : 's'} available →</div>
        </div>
      </div>`;
    }
    function cardHtml(key) {
      const c = CARDS[key] || NEW_MARKET_CARDS[key];
      if (!c) return '';
      // A card can be withheld per region with hideIn: ['uk'] — the programme does not
      // run there yet. renderGroups filters empty cells out and skips a group that ends
      // up with none, so the card simply is not there rather than being shown disabled.
      if (Array.isArray(c.hideIn) && c.hideIn.indexOf(currentRegionCode) > -1) return '';
      // Card colour follows the same level rule as the tiles + the homepage; the
      // CARDS `st` names the programme it represents (perf-analysis-team is still
      // performance-analysis). EPAC Club renders dark so it stands out.
      const st = c.st || key;
      const dark = isDarkCard(st);
      const shell = dark ? 'epac-bg-navy epac-border-navy' : 'epac-border-gray-200';
      const titleCls = dark ? 'epac-text-white' : 'epac-text-navy';
      const descCls = dark ? 'epac-text-white/70' : 'epac-text-mute';
      const ctaCls = dark ? 'epac-text-white' : 'epac-text-red';
      return `<a href="${c.href}" class="epac-tile epac-block epac-rounded-2xl epac-border ${shell} epac-overflow-hidden epac-no-underline">
        <div style="height:5px;background:${accentFor(st, c.level)}"></div>
        <div class="epac-p-5">
          <div class="epac-flex epac-items-start epac-justify-between epac-gap-2 epac-mb-2"><span class="epac-text-2xl">${c.icon}</span>${badgeHtml(c.badge, dark)}</div>
          <div class="epac-font-semibold ${titleCls} epac-text-lg">${escapeHtml(c.title)}</div>
          ${c.step ? `<div class="epac-mt-1.5 epac-mb-2">${stepHtml(c.step)}</div>` : ''}
          <div class="epac-text-sm ${descCls} epac-mb-3">${escapeHtml(c.desc)}</div>
          <div class="epac-text-xs epac-font-semibold ${ctaCls}">Learn more →</div>
        </div>
      </a>`;
    }
    function renderGroups() {
      const aud = AUDIENCES.indexOf(AUDIENCE) > -1 ? AUDIENCE : 'athlete';
      // A region we haven't launched in gets the SIMPLE list — only what actually
      // travels there — not the full launched groups (which are US-only).
      const newMarket = !isLaunched(currentRegionCode);
      const groups = (newMarket ? NEW_MARKET_GROUPS[aud] : GROUPS[aud]) || [];
      // No banner above the groups in any region. An established region with a
      // scheduling gap never had one (owner 2026-07-14) because its groups still
      // carry real actions, and the "EPAC is coming" panel that unlaunched regions
      // used to get was removed on 2026-08-07: EPAC has already operated in EU and
      // AU, so a future-launch panel misdescribed them. Every group now carries its
      // own fallback card, which is where the register-interest route lives.
      let html = '';
      for (const g of groups) {
        const cells = g.members.map((m) => {
          if (!m.tile) return cardHtml(m.card);
          const tile = tileHtml(m.tile);
          // A tile with nothing on sale renders empty and the service vanishes
          // from the page. Where a member declares `fallback`, show that card
          // instead — and it stops showing the moment real sessions exist.
          return tile || (m.fallback ? cardHtml(m.fallback) : '');
        }).filter(Boolean);
        if (!cells.length) continue; // never render an empty group header
        // Opens in a new tab so a parent mid-booking does not lose the finder.
        const groupCta = (g.scheduleLink && currentRegionCode === 'us' && SCHEDULE.link)
          ? `<a class="epac-chapter-cta" href="${escapeHtml(SCHEDULE.link)}" target="_blank" rel="noopener noreferrer">${escapeHtml(SCHEDULE.label)} &rarr;</a>`
          : '';
        html += `<section class="epac-chapter" style="--epac-g:${cssColor(g.accent)}">
          <div class="epac-chapter-head">
            <div class="epac-chapter-bar"></div>
            <h3 class="epac-chapter-title">${escapeHtml(g.label)}</h3>
            ${groupCta}
          </div>
          <div class="epac-grid sm:epac-grid-cols-2 lg:epac-grid-cols-3 epac-gap-4">${cells.join('')}</div>
        </section>`;
      }
      groupsEl.innerHTML = html;
      groupsEl.querySelectorAll('[data-programme]').forEach((t) => t.addEventListener('click', () => openProgramme(t.dataset.programme)));
    }

    function openProgramme(pt) {
      programme = pt;
      filters = { focus: 'all', state: 'all', age: [], when: [], level: 'all', venue: 'all' };
      shown = PAGE_SIZE;
      const meta = PROGRAMME_META[pt];
      root.querySelector('[data-epac-finder-eyebrow]').textContent = (meta.name || pt).toUpperCase();
      root.querySelector('[data-epac-finder-title]').textContent = meta.name || pt;
      const introEl = root.querySelector('[data-epac-finder-intro]');
      introEl.innerHTML = groupIntros[pt] || '';
      // "What's included" cards, if this programme has any (Step 1c).
      root.querySelector('[data-epac-finder-cards]').innerHTML = groupCards[pt] || '';
      step1El.classList.add('epac-hidden');
      step2El.classList.remove('epac-hidden');
      buildFilterUI();
      applyFilters();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function backToProgrammes() {
      programme = null;
      step2El.classList.add('epac-hidden');
      step1El.classList.remove('epac-hidden');
    }
    root.querySelector('[data-epac-back-programmes]').addEventListener('click', backToProgrammes);
    root.querySelector('[data-epac-clear-filters]').addEventListener('click', () => { filters = { focus: 'all', state: 'all', age: [], when: [], level: 'all', venue: 'all' }; shown = PAGE_SIZE; buildFilterUI(); applyFilters(); });

    // ---- STEP 2: filters ----
    function base() { return sessionsForProgramme(programme); }
    function pillsSingle(el, vals, key, label) {
      el.innerHTML = vals.map((v) => `<button type="button" class="epac-pill${filters[key] === v ? ' is-active' : ''}" data-v="${escapeHtml(v)}">${escapeHtml(label(v))}</button>`).join('');
      el.querySelectorAll('button').forEach((b) => b.addEventListener('click', () => { filters[key] = b.dataset.v; shown = PAGE_SIZE; if (key === 'state') filters.venue = 'all'; buildFilterUI(); applyFilters(); }));
    }
    function pillsMulti(el, vals, key) {
      const arr = filters[key];
      let html = `<button type="button" class="epac-pill${arr.length === 0 ? ' is-active' : ''}" data-all="1">All</button>`;
      html += vals.map((v) => `<button type="button" class="epac-pill${arr.includes(v) ? ' is-active' : ''}" data-v="${escapeHtml(v)}">${escapeHtml(v)}</button>`).join('');
      el.innerHTML = html;
      el.querySelector('[data-all]').addEventListener('click', () => { filters[key] = []; shown = PAGE_SIZE; buildFilterUI(); applyFilters(); });
      el.querySelectorAll('[data-v]').forEach((b) => b.addEventListener('click', () => {
        const a = filters[key]; const i = a.indexOf(b.dataset.v); if (i >= 0) a.splice(i, 1); else a.push(b.dataset.v);
        shown = PAGE_SIZE; buildFilterUI(); applyFilters();
      }));
    }
    function buildFilterUI() {
      const rows = base();
      root.querySelector('[data-epac-state-label]').textContent = citySubLabel(currentRegionCode).toUpperCase();

      // Focus / programme sub-filter (Striker / Technical / GK) — only when the
      // programme actually spans more than one focus (e.g. Position-Specific).
      const focuses = [...new Set(rows.map((s) => s.focus).filter(Boolean))];
      toggleRow('[data-epac-f-focus-row]', focuses.length > 1);
      if (focuses.length > 1) pillsSingle(root.querySelector('[data-epac-f-focus]'), ['all', ...focuses], 'focus', (v) => v === 'all' ? 'All' : v);
      else filters.focus = 'all';

      const states = [...new Set(rows.flatMap((s) => s.states))].filter(Boolean);
      toggleRow('[data-epac-f-state-row]', states.length > 0);
      pillsSingle(root.querySelector('[data-epac-f-state]'), ['all', ...states], 'state', (v) => v === 'all' ? 'All' : v);

      const ages = AGES.filter((a) => rows.some((s) => s.ageBand.some((b) => ageOverlaps(b, a))));
      toggleRow('[data-epac-f-age-row]', ages.length > 0);
      pillsMulti(root.querySelector('[data-epac-f-age]'), ages, 'age');

      const months = [...new Set(rows.map((s) => s.month).filter(Boolean))].sort((a, b) => MONTH_ORDER.indexOf(a) - MONTH_ORDER.indexOf(b));
      toggleRow('[data-epac-f-when-row]', months.length > 0);
      pillsMulti(root.querySelector('[data-epac-f-when]'), months, 'when');

      const levels = [...new Set(rows.flatMap((s) => s.level))].map((l) => LEVEL_LABEL[l] || l);
      toggleRow('[data-epac-f-level-row]', levels.length > 0);
      pillsSingle(root.querySelector('[data-epac-f-level]'), ['all', ...levels], 'level', (v) => v === 'all' ? 'All levels' : v);
    }
    function toggleRow(sel, show) { const el = root.querySelector(sel); if (el) el.classList.toggle('epac-hidden', !show); }

    // ---- ordering: cluster by focus · venue · age, then Block 1→4 / earliest date ----
    const BLOCK_ORDER = { 'Block One': 1, 'Block Two': 2, 'Block Three': 3, 'Block Four': 4, 'Full Programme': 5, 'Block Booking': 6 };
    // Sort by the youngest age the session accepts, read off the band itself, so a
    // new band never has to be added to a lookup table to sort correctly.
    const FOCUS_ORDER = { Striker: 0, GK: 1, Defender: 2 };
    function minAge(s) {
      const rs = s.ageBand.map((b) => ageRange(formatAgeBand(b))).filter(Boolean);
      return rs.length ? Math.min.apply(null, rs.map((r) => r[0])) : 99;
    }
    // Sessions write their date TWO ways and both have to parse. The weekly session
    // variants read "Mon 31 Aug" (day first); the holiday camp reads "Dec 21, 9:00 AM"
    // (month first). The old regex matched month-first only, so 81% of rows scored "no
    // date" and fell into arbitrary order behind the venue/age clustering.
    //
    // Returns YYYYMMDD, so it compares as a plain number, and Infinity when there is no
    // date at all (enquiry rows) — which sorts those last rather than first.
    const MON_RE = '(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)';
    function monthIndex(txt) {
      const t = String(txt).toLowerCase().slice(0, 3);
      return MONTH_ORDER.findIndex((x) => x.toLowerCase() === t);
    }
    function firstDateVal(s) {
      const raw = String((s.when && looksLikeDate(s.when)) ? s.when : (s.datesList || s.when || ''));
      // Take the year out FIRST and blank it, or "January 2027" reads 20 as the day.
      const ym = raw.match(/\b(20\d{2})\b/);
      const src = raw.replace(/\b20\d{2}\b/g, ' ');
      let day = null, mi = -1, m;
      if ((m = src.match(new RegExp('\\b(\\d{1,2})\\s*(?:st|nd|rd|th)?\\s+' + MON_RE, 'i')))) {
        day = Number(m[1]); mi = monthIndex(m[2]);
      } else if ((m = src.match(new RegExp(MON_RE + '[a-z]*\\.?\\s+(\\d{1,2})', 'i')))) {
        mi = monthIndex(m[1]); day = Number(m[2]);
      } else if ((m = src.match(new RegExp('\\b' + MON_RE, 'i')))) {
        mi = monthIndex(m[1]); day = 1;
      }
      if (mi < 0) return Infinity;
      if (!(day >= 1 && day <= 31)) day = 1;
      // No year written: assume the next occurrence, so a January session sorts after
      // an August one in the same season instead of leaping to the front.
      let year;
      if (ym) year = Number(ym[1]);
      else {
        const now = new Date();
        year = now.getFullYear();
        const cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 14);
        if (new Date(year, mi, day) < cutoff) year += 1;
      }
      return year * 10000 + (mi + 1) * 100 + day;
    }
    // Same-day sessions read down the clock rather than by venue.
    function timeVal(s) {
      const m = /(\d{1,2}):(\d{2})\s*(?:-\s*\d{1,2}:\d{2}\s*)?(am|pm)/i.exec(s.time || s.when || '');
      if (!m) return 9999;
      let h = Number(m[1]) % 12;
      if (/pm/i.test(m[3])) h += 12;
      return h * 60 + Number(m[2]);
    }
    function sortSessions(arr) {
      // CHRONOLOGICAL FIRST (owner, 2026-08-25): whatever happens soonest leads, for
      // every service type. Date used to be the LAST tiebreaker, behind focus, venue,
      // age and block, which scattered dates through the list. Those keys survive as
      // tiebreakers so same-day sessions still order predictably.
      return arr.slice().sort((a, b) => {
        const da = firstDateVal(a), db = firstDateVal(b); if (da !== db) return da - db;
        const ta = timeVal(a), tb = timeVal(b); if (ta !== tb) return ta - tb;
        const fa = (a.focus in FOCUS_ORDER) ? FOCUS_ORDER[a.focus] : 9;
        const fb = (b.focus in FOCUS_ORDER) ? FOCUS_ORDER[b.focus] : 9;
        if (fa !== fb) return fa - fb;
        const va = a.venue || '~', vb = b.venue || '~'; if (va !== vb) return va.localeCompare(vb);
        const aa = minAge(a), ab = minAge(b); if (aa !== ab) return aa - ab;
        return (BLOCK_ORDER[a.groupLabel] || 0) - (BLOCK_ORDER[b.groupLabel] || 0);
      });
    }
    // The finder cannot tell a member from anyone else, so the price on the card is the
    // list price for everyone. The 100% membership discount is only applied at the
    // checkout step. Without saying so, a member watches a full-price cart all the way
    // through and reasonably concludes their membership is not working.
    //
    // Only shown on sessions a membership actually covers — camps, private training and
    // analysis are not included, and promising $0 there would be a lie.
    const MEMBER_COVERED = ['foundations-first', 'mastering-the-ball', 'defending-denying', 'creating-finishing', 'complete-goalkeeping'];
    // Full-timetable link, shown only beside the specialist-sessions heading and only in
    // the US, because the schedule it points at is the US weekly timetable.
    let SCHEDULE = { link: '', label: 'See the full schedule' };
    try { SCHEDULE = Object.assign(SCHEDULE, JSON.parse(document.querySelector('[data-epac-schedule]').textContent) || {}); } catch (e) {}
    let MEMBER_NOTE = '';
    try { MEMBER_NOTE = JSON.parse(document.querySelector('[data-epac-member-note]').textContent) || ''; } catch (e) {}
    function memberNoteHtml(s) {
      if (!MEMBER_NOTE) return '';
      if (s.endpoint === 'enquiry' || s.endpoint === 'register') return '';
      if (MEMBER_COVERED.indexOf(s.serviceType) === -1) return '';
      // Inline SVG rather than the epac-icon snippet: this runs inside the javascript
      // block, where Liquid does not render.
      const tag = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';
      return `<div class="epac-membernote">${tag}<span>${escapeHtml(MEMBER_NOTE)}</span></div>`;
    }
    function groupKeyOf(s) { return (s.focus || '') + '|' + (s.venue || '') + '|' + s.ageBand.slice().sort().join(','); }
    function groupTitleOf(s) {
      const parts = [];
      if (s.focus) parts.push(s.focus);
      if (s.venue) parts.push(s.venue);
      if (s.ageBand.length) parts.push(s.ageBand.map(formatAgeBand).join(', '));
      return parts.join(' · ');
    }

    function filtered() {
      let r = base();
      if (filters.focus !== 'all') r = r.filter((s) => s.focus === filters.focus);
      if (filters.state !== 'all') r = r.filter((s) => s.states.includes(filters.state));
      if (filters.age.length) r = r.filter((s) => !s.ageBand.length || s.ageBand.some((b) => filters.age.some((a) => ageOverlaps(b, a))));
      if (filters.when.length) r = r.filter((s) => !s.month || filters.when.includes(s.month));
      if (filters.level !== 'all') r = r.filter((s) => !s.level.length || s.level.map((l) => LEVEL_LABEL[l] || l).includes(filters.level));
      if (filters.venue !== 'all') r = r.filter((s) => s.venue === filters.venue);
      return sortSessions(r);
    }
    function applyFilters() {
      // venue dropdown reflects the current (state-narrowed) set
      let forVenues = base();
      if (filters.state !== 'all') forVenues = forVenues.filter((s) => s.states.includes(filters.state));
      const venues = [...new Set(forVenues.map((s) => s.venue).filter(Boolean))];
      const sel = root.querySelector('[data-epac-f-venue]');
      sel.innerHTML = `<option value="all">All venues</option>` + venues.map((v) => `<option value="${escapeHtml(v)}"${filters.venue === v ? ' selected' : ''}>${escapeHtml(v)}</option>`).join('');
      if (!venues.includes(filters.venue)) filters.venue = 'all';
      sel.onchange = () => { filters.venue = sel.value; shown = PAGE_SIZE; applyFilters(); };
      toggleRow('[data-epac-f-venue-row]', venues.length > 0);

      const r = filtered();
      // Re-rendering the list detaches any open detail card — reset its state.
      openDetailEl = null; openSessionId = null;
      root.querySelector('[data-epac-result-count]').textContent = r.length;
      const slice = r.slice(0, shown);
      // Cluster the rows under a small heading when the list spans more than one
      // group (e.g. Striker · Foskett Park · U9–U11), so blocks read in order.
      // Group headers only work when each group is one unbroken run. Sorting by date
      // first interleaves venues and ages, so a header would repeat every few rows and
      // end up labelling the wrong sessions. Detect that and drop the headers instead
      // of printing misleading ones; lists that ARE naturally clustered keep them.
      const gkeys = slice.map(groupKeyOf);
      const contiguous = gkeys.every((k, i) => i === 0 || k === gkeys[i - 1] || gkeys.indexOf(k) === i);
      const showGroups = new Set(gkeys).size > 1 && contiguous;
      // Bucket the FULL filtered set, not the paginated slice: a group's bar colour
      // must not change when "show more" reveals later sessions of another level.
      const groupRows = new Map();
      if (showGroups) {
        for (const s of r) {
          const k = groupKeyOf(s);
          if (!groupRows.has(k)) groupRows.set(k, []);
          groupRows.get(k).push(s);
        }
      }
      let html = '', lastKey = null;
      for (const s of slice) {
        if (showGroups) {
          const gk = groupKeyOf(s);
          if (gk !== lastKey) {
            const t = groupTitleOf(s);
            // Group header (e.g. "Striker · Foskett Park · U6–U8, U9–U11"). It used
            // to be tiny eyebrow text that got lost between rows — now a real
            // section header: a level/pathway-colour bar, bold navy at readable
            // size, and a hairline rule carrying the eye across.
            if (t) {
              const accent = groupBarAccent(groupRows.get(gk) || [s]);
              html += `<div class="epac-flex epac-items-center epac-gap-3 epac-mt-8 first:epac-mt-0 epac-mb-3">
                <span class="epac-w-1 epac-h-6 epac-rounded-full epac-flex-none" style="background:${accent}"></span>
                <span class="epac-text-navy epac-font-bold epac-text-lg epac-leading-tight">${escapeHtml(t)}</span>
                <span class="epac-flex-1 epac-h-px epac-bg-gray-200 epac-hidden sm:epac-block"></span>
              </div>`;
            }
            lastKey = gk;
          }
        }
        html += rowHtml(s);
      }
      resultsEl.innerHTML = html || `<div class="epac-text-center epac-text-mute epac-py-10">No sessions match. Try clearing a filter.</div>`;
      resultsEl.querySelectorAll('[data-epac-session]').forEach((rowEl) => {
        const id = Number(rowEl.dataset.epacSession);
        rowEl.addEventListener('click', () => openSessionDetail(id, rowEl));
        rowEl.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openSessionDetail(id, rowEl); } });
      });
      loadMoreEl.classList.toggle('epac-hidden', r.length <= shown);
    }
    loadMoreEl.addEventListener('click', () => { shown += PAGE_SIZE; applyFilters(); });

    function spotsHtml(s) {
      if (s.left == null) return '';
      const pct = s.total ? Math.round((s.left / s.total) * 100) : 0;
      const col = pct > 50 ? '#16a34a' : '#E30613';
      return `<span class="epac-text-xs epac-font-semibold" style="color:${col}">${s.left} of ${s.total} spots</span>`;
    }
    // Compact scannable row — clicking it opens the full detail card below.
    // Card colour by LEVEL, not programme (owner 2026-07-15) — mirrors
    // epac-programmes' accentFor(); keep the two in step.
    //   Rec / Development -> light blue   Competitive -> red
    //   Academy           -> gold         EPAC Club     -> dark navy card (stands out)
    // A tile aggregates many sessions, so it takes the level of what it contains:
    // any competitive session makes it a performance (red) programme.
    const ACCENT_BLUE = '#0077B6', ACCENT_RED = '#E30613', ACCENT_GOLD = '#FFB703', ACCENT_FC = '#94A3B8';
    function accentFor(serviceType, levels) {
      if (serviceType === 'epac-club') return ACCENT_FC;
      if (serviceType === 'academy' || serviceType === 'membership') return ACCENT_GOLD;
      const l = levels || [];
      if (l.indexOf('academy') > -1) return ACCENT_GOLD;
      if (l.indexOf('competitive') > -1) return ACCENT_RED;
      return ACCENT_BLUE;
    }
    // Dark shell = "this one is different from the row it sits in". EPAC Club is the
    // elite end of the pathway; Membership is a subscription sitting among per-session
    // tiles. Keep this list short or the contrast stops meaning anything.
    const isDarkCard = (serviceType) => serviceType === 'epac-club' || serviceType === 'membership';

    // Venue-group header bar: follows the sessions' own LEVEL/pathway rather than
    // the programme tile's colour (owner 2026-07-16). Separate from accentFor()
    // above, which the tiles/cards use and which has no "mixed" rule — don't merge
    // them, the two answer different questions.
    // Note ACCENT_FC is the SLATE the EPAC Club card uses; this bar wants true navy.
    const ACCENT_NAVY = '#020E38';
    const LEVEL_ACCENT = { rec: ACCENT_BLUE, development: ACCENT_BLUE, competitive: ACCENT_RED, academy: ACCENT_GOLD };
    function groupBarAccent(rows) {
      // service_type wins for these two: academy products carry level
      // ["competitive"], so reading level first would paint the pathway red.
      const st = rows.length ? rows[0].serviceType : '';
      if (st === 'epac-club') return ACCENT_NAVY;
      if (st === 'academy') return ACCENT_GOLD;
      const levels = [...new Set(rows.reduce((acc, s) => acc.concat(s.level || []), []))];
      // Spans more than one level — or records none at all, as coach education and
      // performance analysis do — so no single level is honest. Navy.
      return levels.length === 1 ? LEVEL_ACCENT[levels[0]] || ACCENT_NAVY : ACCENT_NAVY;
    }

    // A product flagged epac.featured is promoted on the homepage — badge it here
    // too so the flag is visible on the internal pages (featured-programmes.md).
    const featuredBadgeHtml = (s) => s.featured
      ? ' <span class="epac-text-[10px] epac-eyebrow epac-font-bold epac-px-2 epac-py-0.5 epac-rounded epac-bg-gold/20 epac-text-[#B8860B]">FEATURED</span>'
      : '';

    // Plain-language hint for multi-session blocks (parent QA #2). "Block One" is
    // jargon — it doesn't tell a parent it's several sessions, or that the price
    // covers ALL of them. Derived from the data (count epac.dates + the schedule
    // day + price) so it stays automatic as staff add blocks, with no hand-written
    // copy to drift.
    // Deliberately does NOT claim "N-week block": the dates legitimately skip weeks
    // (e.g. Oct 30 · Nov 6 · 13 · 20 · Dec 4 jumps Nov 27), so a week count derived
    // from the session count would be wrong. Only state what the data proves.
    function blockHintOf(s) {
      const dates = String(s.datesList || '').split('·').map((x) => x.trim()).filter(Boolean);
      if (dates.length < 2) return ''; // single-session rows need no explaining
      const dayMatch = String(s.time || '').match(/\b(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)s?\b/i);
      const day = dayMatch ? dayMatch[1] : '';
      const total = (Number(s.price) > 0 && s.priceFormatted) ? `${s.priceFormatted} total` : '';
      return [`${dates.length}${day ? ' ' + day : ''} sessions`, total].filter(Boolean).join(' · ');
    }

    function rowHtml(s) {
      const cta = s.endpoint === 'enquiry' ? 'View & enquire' : (s.endpoint === 'register' ? 'View & register' : 'View & book');
      const hint = blockHintOf(s);
      const whenShort = s.when && s.when.length > 30 ? s.when.slice(0, 28) + '…' : s.when;
      const meta = [s.remote ? '' : (s.states[0] || ''), whenShort, s.time].filter(Boolean).join(' · ');
      const chips = [...s.ageBand.map(formatAgeBand), ...s.level.map((l) => LEVEL_LABEL[l] || l)]
        .map((c) => `<span class="epac-text-[10px] epac-eyebrow epac-font-bold epac-px-2 epac-py-0.5 epac-rounded epac-bg-gray-100 epac-text-slate">${escapeHtml(c)}</span>`).join('');
      const thumb = s.image
        ? `<img src="${escapeHtml(s.image)}" class="epac-w-16 epac-h-16 epac-rounded-xl epac-object-cover epac-flex-none epac-hidden sm:epac-block" alt="">`
        : `<div class="epac-w-16 epac-h-16 epac-rounded-xl epac-bg-navy epac-flex-none epac-hidden sm:epac-flex epac-items-center epac-justify-center"><img src="${EPAC_LOGO_URL}" class="epac-w-8 epac-h-8 epac-object-contain epac-opacity-70" alt=""></div>`;
      return `<div class="epac-sess epac-rounded-2xl epac-border epac-border-gray-200 epac-p-4 epac-flex epac-flex-col sm:epac-flex-row sm:epac-items-center epac-gap-3 epac-cursor-pointer" data-epac-session="${s._id}" role="button" tabindex="0">
        ${thumb}
        <div class="epac-flex-1 epac-min-w-0">
          <div class="epac-font-semibold epac-text-navy">${escapeHtml(titleOf(s))}${s.remote ? ' <span class="epac-text-[10px] epac-eyebrow epac-font-bold epac-px-2 epac-py-0.5 epac-rounded epac-bg-blue/10 epac-text-blue">REMOTE</span>' : ''}${featuredBadgeHtml(s)}</div>
          ${meta ? `<div class="epac-text-sm epac-text-mute">${escapeHtml(meta)}</div>` : ''}
          ${hint ? `<div class="epac-text-xs epac-font-semibold epac-text-blue epac-mt-1">${escapeHtml(hint)}</div>` : ''}
          ${chips ? `<div class="epac-flex epac-flex-wrap epac-gap-1.5 epac-mt-2">${chips}</div>` : ''}
        </div>
        <div class="sm:epac-text-right epac-flex sm:epac-flex-col epac-items-center sm:epac-items-end epac-gap-3 sm:epac-gap-1">
          <div>${spotsHtml(s)}</div>
          <div class="epac-text-xl epac-font-extrabold epac-text-navy">${escapeHtml(s.priceFormatted)}</div>
          <span class="epac-text-xs epac-font-semibold epac-text-red epac-pointer-events-none">${cta} →</span>
        </div>
      </div>`;
    }

    // ---- session DETAIL (expand-in-place on row click) ----
    let openDetailEl = null;
    let openSessionId = null;
    function closeDetail() { if (openDetailEl) openDetailEl.remove(); openDetailEl = null; openSessionId = null; }
    function openSessionDetail(id, rowEl) {
      if (openSessionId === id) { closeDetail(); return; }
      closeDetail();
      const s = SESSIONS[id];
      if (!s) return;
      const wrap = document.createElement('div');
      wrap.innerHTML = sessionDetailHtml(s);
      const detail = wrap.firstElementChild;
      rowEl.insertAdjacentElement('afterend', detail);
      openDetailEl = detail;
      openSessionId = id;
      wireDetail(detail, s);
      detail.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    function detailRow(k, v) { return `<div class="epac-detail-row"><span class="epac-k">${escapeHtml(k)}</span><span class="epac-v">${escapeHtml(v)}</span></div>`; }
    function spotsBarBig(left, total) {
      if (left == null) return '';
      const tot = total || left || 1;
      const pct = Math.max(4, Math.min(100, Math.round((left / tot) * 100)));
      const col = pct > 50 ? '#16a34a' : '#E30613';
      return `<div class="epac-mt-4">
        <div class="epac-flex epac-justify-between epac-text-xs epac-font-semibold epac-mb-1"><span style="color:${col}">${left} of ${tot} spots left</span></div>
        <div class="epac-h-2 epac-rounded-full epac-bg-gray-200 epac-overflow-hidden"><div class="epac-h-full epac-rounded-full" style="width:${pct}%;background:${col}"></div></div>
      </div>`;
    }
    function sessionDetailHtml(s) {
      const isEnquiry = s.endpoint === 'enquiry';
      const isRegister = s.endpoint === 'register';
      const loc = s.remote ? 'Remote' : s.states.join(', ');
      const rows = [];
      if (s.category) rows.push(detailRow('Category', s.category));
      if (s.field) rows.push(detailRow('Field', s.field));
      if (loc) rows.push(detailRow('Location', loc));
      if (s.level.length) rows.push(detailRow('Level', s.level.map((l) => LEVEL_LABEL[l] || l).join(', ')));
      if (s.ageBand.length) rows.push(detailRow('Ages', s.ageBand.map(formatAgeBand).join(', ')));
      // Single dated session → its date; block/bundle → the full multi-date list.
      const datesVal = (s.when && looksLikeDate(s.when)) ? s.when : (s.datesList || '');
      if (datesVal) rows.push(detailRow('Dates', datesVal));
      if (s.when && !looksLikeDate(s.when) && s.when !== s.datesList) rows.push(detailRow('Session', s.when));
      if (s.time) rows.push(detailRow('Time', s.time));
      if (s.capacity) rows.push(detailRow('Capacity', `${s.capacity} player${s.capacity === 1 ? '' : 's'}`));
      // Spell out what a "Block" actually buys, right where the parent commits.
      const detailHint = blockHintOf(s);
      if (detailHint) rows.push(detailRow('Includes', detailHint));

      const img = s.imageLarge
        ? `<div class="epac-aspect-[16/10] epac-w-full epac-bg-gray-100 epac-overflow-hidden"><img src="${escapeHtml(s.imageLarge)}" alt="${escapeHtml(s.venue || '')}" class="epac-w-full epac-h-full epac-object-cover epac-object-center"></div>`
        : `<div class="epac-aspect-[16/10] epac-w-full epac-bg-navy epac-flex epac-items-center epac-justify-center"><img src="${EPAC_LOGO_URL}" alt="EPAC" class="epac-w-24 epac-h-24 epac-object-contain epac-opacity-80"></div>`;

      // Delivery-mode picker (In-Person / Online). Selecting a mode swaps the
      // variant added + updates the price and spots below (wired in wireDetail).
      const mode = s.modes ? s.modes[s.modeIdx || 0] : null;
      const modeHtml = (s.modes && s.modes.length > 1)
        ? `<div class="epac-mb-3" data-epac-modes>
            <div class="epac-text-[11px] epac-eyebrow epac-font-bold epac-text-mute epac-mb-1.5">Delivery</div>
            <div class="epac-flex epac-flex-wrap epac-gap-2">${s.modes.map((m, i) => {
              const soldOut = m.left != null && m.left <= 0;
              const active = i === (s.modeIdx || 0);
              return `<button type="button" data-epac-mode="${i}"${soldOut ? ' disabled' : ''} class="epac-px-3 epac-py-2 epac-rounded-xl epac-border epac-text-sm epac-font-semibold ${active ? 'epac-border-navy epac-bg-navy epac-text-white' : 'epac-border-gray-300 epac-text-navy'}${soldOut ? ' epac-opacity-40 epac-line-through' : ''}">${escapeHtml(m.name)} · ${escapeHtml(m.priceFormatted)}</button>`;
            }).join('')}</div>
          </div>`
        : '';

      const qtyHtml = (!isRegister && !isEnquiry)
        ? `<div class="epac-flex epac-items-center epac-border epac-border-gray-300 epac-rounded-xl epac-overflow-hidden"><button type="button" data-epac-qty-dec class="epac-px-3 epac-py-2 epac-text-lg epac-leading-none">−</button><span data-epac-qty class="epac-px-3 epac-min-w-[2.5rem] epac-text-center epac-font-semibold">1</span><button type="button" data-epac-qty-inc class="epac-px-3 epac-py-2 epac-text-lg epac-leading-none">+</button></div>`
        : '';
      const priceShown = mode ? mode.priceFormatted : s.priceFormatted;
      const priceHtml = isEnquiry ? '' : `<span data-epac-price class="epac-text-2xl epac-font-extrabold epac-text-navy">${escapeHtml(priceShown)}</span>`;
      const addControl = isEnquiry
        ? `<a href="/pages/contact" class="epac-block epac-text-center epac-w-full epac-bg-navy epac-text-white epac-font-semibold epac-py-3 epac-rounded-xl epac-mt-3 epac-no-underline">Enquire →</a>`
        : `<button type="button" data-epac-add class="epac-w-full ${isRegister ? 'epac-bg-navy' : 'epac-btn-red'} epac-text-white epac-font-semibold epac-py-3 epac-rounded-xl epac-mt-3">${isRegister ? 'Register' : 'Add to booking'}</button>`;

      return `<div class="epac-detail epac-rounded-2xl epac-border epac-border-navy epac-overflow-hidden epac-mt-1 epac-mb-1">
        <div class="epac-grid lg:epac-grid-cols-5">
          <div class="lg:epac-col-span-3">${img}</div>
          <div class="lg:epac-col-span-2 epac-p-5">
            <div class="epac-font-bold epac-text-navy epac-text-lg epac-leading-tight epac-mb-2">${escapeHtml(titleOf(s))}${s.remote ? ' <span class="epac-text-[10px] epac-eyebrow epac-font-bold epac-px-2 epac-py-0.5 epac-rounded epac-bg-blue/10 epac-text-blue">REMOTE</span>' : ''}${featuredBadgeHtml(s)}</div>
            ${rows.join('')}
            ${modeHtml}
            <div data-epac-spots>${spotsBarBig(mode ? mode.left : s.left, s.total)}</div>
            <div class="epac-flex epac-items-center epac-justify-between epac-mt-4 epac-gap-3">${priceHtml}${qtyHtml}</div>
            ${addControl}
            ${memberNoteHtml(s)}
          </div>
        </div>
      </div>`;
    }
    function wireDetail(detail, s) {
      const addBtn = detail.querySelector('[data-epac-add]');
      if (!addBtn) return; // enquiry renders an anchor — nothing to wire
      const qtyEl = detail.querySelector('[data-epac-qty]');
      let qty = 1;
      const setQty = (n) => { qty = Math.max(1, n); if (qtyEl) qtyEl.textContent = qty; };
      const dec = detail.querySelector('[data-epac-qty-dec]');
      const inc = detail.querySelector('[data-epac-qty-inc]');
      if (dec) dec.addEventListener('click', () => setQty(qty - 1));
      if (inc) inc.addEventListener('click', () => setQty(qty + 1));

      // Delivery-mode picker: track the chosen variant + reflect its price/spots.
      let variantId = s.variantId;
      let modeName = s.modes ? s.modes[s.modeIdx || 0].name : '';
      const priceEl = detail.querySelector('[data-epac-price]');
      const spotsEl = detail.querySelector('[data-epac-spots]');
      detail.querySelectorAll('[data-epac-mode]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const i = Number(btn.dataset.mode);
          const m = s.modes[i];
          if (!m || (m.left != null && m.left <= 0)) return;
          variantId = m.id;
          modeName = m.name;
          if (priceEl) priceEl.textContent = m.priceFormatted;
          if (spotsEl) spotsEl.innerHTML = spotsBarBig(m.left, s.total);
          detail.querySelectorAll('[data-epac-mode]').forEach((b, j) => {
            const active = j === i;
            b.classList.toggle('epac-bg-navy', active);
            b.classList.toggle('epac-text-white', active);
            b.classList.toggle('epac-border-navy', active);
            b.classList.toggle('epac-text-navy', !active);
            b.classList.toggle('epac-border-gray-300', !active);
          });
        });
      });

      addBtn.addEventListener('click', () => {
        const label = (s.venue || s.productTitle) + (modeName ? ' · ' + modeName : '') + (s.when ? ' · ' + s.when : '') + (s.time ? ' ' + s.time : '');
        addToCart(variantId, s.endpoint === 'register' ? 1 : qty, label);
      });
    }

    // ---- real Shopify cart ----
    // The branded slide-out drawer (snippets/epac-cart-drawer) is the single
    // canonical cart surface: it renders line items, does qty/remove, and
    // broadcasts state on the shared `epaccartupdate` event. This bar is a slim
    // summary that opens the drawer; it only READS the broadcast (never
    // re-broadcasts) so header badge + bar + drawer stay in sync with no loop.
    const cartBarEl = document.querySelector('[data-epac-cart-bar]');
    const cartSummaryEl = document.querySelector('[data-epac-cart-summary]');
    const cartTotalEl = document.querySelector('[data-epac-cart-total]');

    async function addToCart(variantId, quantity, label) {
      const numericId = String(variantId).replace(/\D/g, '');
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: numericId, quantity }] }) });
        if (!res.ok) throw new Error('Add to cart failed');
        // The drawer refreshes + broadcasts on open, which updates this bar.
        if (window.EpacCart) window.EpacCart.open();
        else window.dispatchEvent(new CustomEvent('epac-cart-open'));
      } catch (err) {
        console.error('EPAC finder: add to cart failed', err);
        alert('Sorry, something went wrong adding that to your booking. Please try again.');
      }
    }
    // Market-aware: cart.js returns the active market's currency ISO (USD/GBP/…),
    // so this matches the region-switched prices rather than always printing "$".
    function formatMoney(cents, currency) {
      const amount = (cents || 0) / 100;
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(amount);
      } catch (_) {
        return `${currency ? currency + ' ' : '$'}${amount.toFixed(2)}`;
      }
    }
    function updateBar(count, total, currency) {
      cartSummaryEl.textContent = `${count} item${count === 1 ? '' : 's'}`;
      cartTotalEl.textContent = formatMoney(total, currency);
      cartBarEl.classList.toggle('epac-hidden', count === 0);
    }
    window.addEventListener('epaccartupdate', (e) => {
      if (e.detail && e.detail.count !== undefined) updateBar(e.detail.count, e.detail.total, e.detail.currency);
    });
    async function refreshCart() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        updateBar(cart.item_count, cart.total_price, cart.currency);
      } catch (_) {}
    }

    // Deep link: /pages/book?service=camps opens that programme's finder.
    // It deliberately does NOT switch region when the service isn't offered where
    // the visitor is. It used to: it grabbed the first session of that type in ANY
    // region and jumped there — so an Australian clicking "Private Training" on the
    // homepage landed in UK bookings (owner 2026-07-14), silently overriding their
    // own region choice for a service they can't actually attend. Now they keep
    // their region and get its tiles, or the reduced new-market groups
    // register-interest card.
    function openDeepLink() {
      const wanted = new URLSearchParams(window.location.search).get('service');
      if (!wanted || !PROGRAMME_META[wanted]) return;
      if (sessionsForProgramme(wanted).length) openProgramme(wanted);
    }

    setRegion(currentRegionCode, false);
    renderGroups();
    refreshCart();
    openDeepLink();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["epac-header"] && !Shopify.designMode) return;
  try {
    
  const epacHdr = document.getElementById('epac-hdr');
  if (epacHdr && epacHdr.dataset.epacHomepage === 'true') {
    const onScroll = () => epacHdr.classList.toggle('epac-solid', window.scrollY > 0);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  document.querySelectorAll('[data-epac-menu-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const menu = btn.closest('header').querySelector('[data-epac-mobile-menu]');
      if (menu) menu.classList.toggle('epac-hidden');
    });
  });

  // Single source of truth for the selected region: localStorage, kept in
  // sync across every component on the page (this header, plus the booking
  // listing's own region pills/cards) via a shared "epacregionchange"
  // window event — not just localStorage, since other open components only
  // read localStorage once at their own load time and have no way to
  // notice a later change made somewhere else without an explicit signal.
  //
  // epacApplyRegion() only updates this component's own DOM (label/mirror
  // text) and never writes storage or dispatches — used both for our own
  // clicks (after epacSetRegion's write+dispatch) and for reacting to a
  // change initiated elsewhere, so receiving our own dispatch back is a
  // harmless no-op rather than a re-dispatch loop.
  function epacApplyRegion(name) {
    document.querySelectorAll('[data-epac-region-label]').forEach((el) => (el.textContent = name));
    document.querySelectorAll('[data-epac-region-label-mirror]').forEach((el) => (el.textContent = name));
    // Marked HERE rather than in the click handlers because this is the single
    // point every region change funnels through: the initial restore from
    // storage, the booking finder's own pills, and both header menus. Marking in
    // the click handler would miss the first two.
    document.querySelectorAll('[data-epac-region-option]').forEach((opt) => {
      const active = opt.dataset.region === name;
      opt.classList.toggle('epac-region-active', active);
      opt.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  // The NAME drives this component's label; the CODE drives the booking finder,
  // Featured Programmes and the interest form. Writing the name without the code
  // let the two drift, which showed as a header reading "United States" over
  // content for another market, and looked like a caching fault rather than
  // divergent storage. So the code is resolved from the option list when the caller
  // does not supply one, and the pair is only ever written together.
  function epacCodeForName(name) {
    const opt = document.querySelector('[data-epac-region-option][data-region="' + String(name).replace(/"/g, '') + '"]');
    return (opt && opt.dataset.regionCode) || null;
  }
  function epacSetRegion(name, code) {
    epacApplyRegion(name);
    const resolved = code || epacCodeForName(name);
    window.localStorage.setItem('epacRegion', name);
    if (resolved) window.localStorage.setItem('epacRegionCode', resolved);
    window.dispatchEvent(new CustomEvent('epacregionchange', { detail: { name, code: resolved } }));
  }

  // Shopify Markets wiring: switch the active market so prices/checkout show the
  // selected region's currency. Region codes are a fixed set (us/uk/eu/au); map
  // each to the country that anchors its market. We only switch when that country
  // is actually a sold-to country AND differs from the current one — so this is a
  // graceful no-op on the dev sandbox (Markets off → only the primary country in
  // `available`), and the `=== current` guard stops a reload loop when the region
  // is restored from storage after the post-switch reload.
  const EPAC_REGION_COUNTRY = { us: 'US', uk: 'GB', eu: 'IE', au: 'AU' };
  let epacLoc = { action: '/localization', current: '', available: [] };
  try {
    const locEl = document.querySelector('[data-epac-localization]');
    if (locEl) epacLoc = Object.assign(epacLoc, JSON.parse(locEl.textContent));
  } catch (_) {}
  function epacSwitchMarket(code) {
    const country = EPAC_REGION_COUNTRY[code];
    if (!country) return;
    if (country === epacLoc.current) return;
    if (epacLoc.available.indexOf(country) === -1) return;
    // Persist the region first so it survives the reload, then hand off to
    // Shopify's own localization endpoint (country_code + return_to → reload).
    const form = document.createElement('form');
    form.method = 'post';
    form.action = epacLoc.action;
    form.hidden = true;
    form.innerHTML =
      '<input type="hidden" name="_method" value="put">' +
      '<input type="hidden" name="form_type" value="localization">' +
      '<input type="hidden" name="country_code">' +
      '<input type="hidden" name="return_to">';
    form.querySelector('[name="country_code"]').value = country;
    form.querySelector('[name="return_to"]').value = window.location.pathname + window.location.search;
    document.body.appendChild(form);
    form.submit();
  }

  // Falls back to the label already rendered by the section setting, so a
  // first-time visitor on a page WITHOUT the booking finder (About, Careers)
  // still sees a marked region instead of four identical pills. Passing that
  // label back in is a no-op for the label itself.
  const epacStoredRegion = window.localStorage.getItem('epacRegion');
  const epacInitialRegion = epacStoredRegion
    || ((document.querySelector('[data-epac-region-label]') || {}).textContent || '').trim();
  if (epacInitialRegion) epacApplyRegion(epacInitialRegion);
  // Heal a pair that drifted apart under the old behaviour: the name is what the
  // visitor last chose and saw, so the code is rewritten to match it.
  if (epacInitialRegion) {
    const want = epacCodeForName(epacInitialRegion);
    if (want && window.localStorage.getItem('epacRegionCode') !== want) {
      window.localStorage.setItem('epacRegionCode', want);
    }
  }

  window.addEventListener('epacregionchange', (e) => {
    if (e.detail && e.detail.name) epacApplyRegion(e.detail.name);
    if (e.detail && e.detail.code) epacSwitchMarket(e.detail.code);
  });

  document.querySelectorAll('[data-epac-region-root]').forEach((root) => {
    const toggle = root.querySelector('[data-epac-region-toggle]');
    const menu = root.querySelector('[data-epac-region-menu]');

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      menu.classList.toggle('epac-hidden');
    });
    document.addEventListener('click', () => menu.classList.add('epac-hidden'));
  });

  // Region options live in two places (desktop dropdown + mobile drawer), and
  // each has its OWN container. Closing only the dropdown left the mobile drawer
  // open over the page: the region changed underneath it, so on a phone the tap
  // looked like it had done nothing. Close whichever one the option sits in.
  document.querySelectorAll('[data-epac-region-option]').forEach((opt) => {
    opt.addEventListener('click', () => {
      epacSetRegion(opt.dataset.region, opt.dataset.regionCode);
      ['[data-epac-region-menu]', '[data-epac-mobile-menu]'].forEach((sel) => {
        const container = opt.closest(sel);
        if (container) container.classList.add('epac-hidden');
      });
    });
  });

  // Cart count badge — shown on every page, kept in sync with add/remove
  // actions from the booking listing via the shared epaccartupdate event.
  function epacApplyCartCount(count) {
    document.querySelectorAll('[data-epac-hdr-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('epac-hidden', count === 0);
    });
  }
  async function epacFetchCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      epacApplyCartCount(cart.item_count);
    } catch (_) {}
  }
  epacFetchCartCount();
  window.addEventListener('epaccartupdate', (e) => {
    if (e.detail && e.detail.count !== undefined) epacApplyCartCount(e.detail.count);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["epac-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-epac-testimonial-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-epac-testimonial-track]');
    const dots = [...carousel.querySelectorAll('[data-epac-testimonial-dot]')];
    const cards = [...track.children];
    const interval = Number(carousel.dataset.interval) || 6000;
    if (!cards.length) return;

    let activeIndex = 0;
    let autoplayTimer = null;
    let isProgrammaticScroll = false;
    let scrollEndTimer = null;

    function setActiveDot(index) {
      activeIndex = index;
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }

    function scrollToIndex(index) {
      isProgrammaticScroll = true;
      // Scroll only the track's own horizontal position — scrollIntoView()
      // can bubble up and move the whole PAGE vertically to "reveal" the
      // card, even with block:'nearest', which is exactly the unwanted
      // page-jump this replaces.
      track.scrollTo({ left: cards[index].offsetLeft, behavior: 'smooth' });
      setActiveDot(index);
      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(() => { isProgrammaticScroll = false; }, 600);
    }

    function goToNext() {
      scrollToIndex((activeIndex + 1) % cards.length);
    }

    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = window.setInterval(goToNext, interval);
    }

    function stopAutoplay() {
      if (autoplayTimer) window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    let resumeTimer = null;
    function pauseThenResume() {
      stopAutoplay();
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(startAutoplay, interval);
    }

    // Manual drag/scroll/touch pauses autoplay and restarts the countdown.
    track.addEventListener('scroll', () => {
      if (isProgrammaticScroll) return;
      pauseThenResume();
      // Figure out which card is nearest the start edge to keep dots in sync
      // with manual scrolling too, not just autoplay.
      let nearest = 0;
      let nearestDistance = Infinity;
      cards.forEach((card, i) => {
        const distance = Math.abs(card.offsetLeft - track.scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearest = i;
        }
      });
      setActiveDot(nearest);
    }, { passive: true });

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('touchstart', stopAutoplay, { passive: true });
    carousel.addEventListener('touchend', pauseThenResume, { passive: true });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        scrollToIndex(Number(dot.dataset.index));
        pauseThenResume();
      });
    });

    setActiveDot(0);
    startAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["epac-video"] && !Shopify.designMode) return;
  try {
    
  // Click-to-load: the YouTube iframe is created only when the play button is
  // pressed, so nothing is fetched from youtube.com on page load. autoplay=1 is
  // safe here because the click IS the user gesture browsers require.
  document.querySelectorAll('[data-epac-yt-player]').forEach((box) => {
    const btn = box.querySelector('[data-epac-yt-play]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const id = box.dataset.yt;
      if (!id) return;
      const f = document.createElement('iframe');
      f.src = 'https://www.youtube.com/embed/' + id + '?rel=0&modestbranding=1&autoplay=1&playsinline=1';
      f.className = 'epac-absolute epac-inset-0 epac-w-full epac-h-full';
      f.setAttribute('frameborder', '0');
      f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      f.setAttribute('allowfullscreen', '');
      f.setAttribute('title', box.dataset.title || 'Video');
      box.innerHTML = '';
      box.appendChild(f);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
